/*
 * Features: News reads and writes through the shared data API.
 * Recent changes: News reads re-evaluate persisted note visibility on every request.
 */

import { z } from "zod";
import { DataRoutes } from "./types";

const newsRoutes: DataRoutes = {
  // Get latest 100 news items sorted by creation date
  'get /api/data/news': {
    query: `EXEC GetNews`,
    cache: false,
  },

  // Create a new news item with entity reference and content
  'post /api/data/news': {
    schema: z.object({
      content: z.string(),
      entityType: z.enum(['account', 'contact']),
      entityId: z.number().int().positive(),
      url: z.string()
    }).strict(),

    query: `
      DECLARE @actorId INT = dbo.fnGetContextUser();

      INSERT INTO [dbo].[News] ([EntityType], [EntityId], [Content], [url], [createdBy])
      SELECT @entityType, @entityId, @content, @url, @actorId
      WHERE @actorId IS NOT NULL
        AND (
          (
            @entityType = N'account'
            AND EXISTS (
              SELECT 1
              FROM [dbo].[Accounts] A
              WHERE A.id = @entityId
            )
          )
          OR (
            @entityType = N'contact'
            AND EXISTS (
              SELECT 1
              FROM [dbo].[Contacts] C
              WHERE C.id = @entityId
            )
          )
        );

      IF @@ROWCOUNT = 0
        THROW 99328, 'Forbidden: news entity is unavailable to current user.', 1;`
  },
}

export default newsRoutes;
